import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {UserAuthData} from "./types";
import {RootState} from "../../store";
import ability, {updateAbility} from "../../utils/ability";

export interface AuthInitialState {
    user: string | null
    refreshToken: string | null
    accessToken: string | null
    expiresTimestamp: number | null
    shortPath: boolean
}

const initialState: AuthInitialState = {
    user: null,
    refreshToken: null,
    accessToken: null,
    expiresTimestamp: null,
    shortPath: false
}

export const authSlice = createSlice({
    name: "auth",
    initialState: initialState,
    reducers: {
        setCredentials: (state, action: PayloadAction<UserAuthData>) => {
            const {profile, accessToken, refreshToken, expiresIn, createdAt} = action.payload
            localStorage.setItem("user", JSON.stringify({
               ...action.payload
            }));
            updateAbility(ability, profile.roles)
            state.user = profile.email
            state.accessToken = accessToken
            state.refreshToken = refreshToken
            state.expiresTimestamp = createdAt + expiresIn
        },
        logOut: (state) => {
            state.user = null
            state.accessToken = null
            state.refreshToken = null
            localStorage.removeItem("user");
        },
        setShortPath: (state, action: PayloadAction<boolean>) => {
            state.shortPath = action.payload
        },
    }
})

export const {setCredentials, logOut, setShortPath} = authSlice.actions;

export const selectCurrentUser = (state: RootState) => state.auth.user;

export const selectRefreshToken = (state: RootState) => state.auth.refreshToken;
export const selectExpiryDate = (state: RootState) => state.auth.expiresTimestamp;

export const selectToken = (state: RootState) => state.auth.accessToken;
export const selectShortPathState = (state: RootState) => state.auth.shortPath;